import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Directory", path: "/catalog" },
  { label: "Categories", path: "/categories" },
  { label: "Featured", path: "/featured" },
  { label: "Groups", path: "/groups" },
  { label: "Community", path: "/forums" },
  { label: "Confessions", path: "/confessions", special: true },
  { label: "Submit", path: "/submit" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navBg = isHome
    ? scrolled
      ? "bg-[#faf8f4] shadow-sm"
      : "bg-transparent"
    : "bg-[#faf8f4] shadow-sm";

  const textColor = isHome && !scrolled ? "text-white" : "text-[#3a2e1e]";
  const logoColor = isHome && !scrolled ? "text-white" : "text-[#3a2e1e]";

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className={`flex items-center gap-1.5 whitespace-nowrap ${logoColor}`} style={{ fontFamily: "'Playfair Display', serif" }}>
          <span className="font-bold text-xl tracking-tight">Junk</span>
          <span className="font-black text-xl" style={{ color: "#f5c518" }}>4</span>
          <span className="font-bold text-xl tracking-tight">Journals</span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm transition-colors hover:opacity-70 whitespace-nowrap ${
                link.special
                  ? "font-bold text-[#c0392b] bg-white px-3 py-1 rounded-full flex items-center gap-1"
                  : `font-medium ${textColor}`
              } ${location.pathname === link.path ? "border-b-2 border-current pb-0.5" : ""}`}
            >
              {link.special && <i className="ri-fire-line text-sm fire-flicker"></i>}
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right Actions */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/admin"
            className={`text-xs font-medium transition-colors hover:opacity-70 whitespace-nowrap ${textColor} opacity-40 hover:opacity-70`}
            title="Admin"
          >
            <i className="ri-shield-keyhole-line"></i>
          </Link>
          <Link
            to="/submit"
            className="px-4 py-2 rounded-full text-sm font-medium bg-[#8b5e3c] text-white hover:bg-[#7a5234] transition-colors whitespace-nowrap"
          >
            Join Directory
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center ${textColor}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#faf8f4] border-t border-[#e8e0d4] px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm transition-colors flex items-center gap-1 ${
                link.special
                  ? "font-bold text-[#c0392b]"
                  : "font-medium text-[#3a2e1e] hover:text-[#8b5e3c]"
              }`}
            >
              {link.special && <i className="ri-fire-line text-sm fire-flicker"></i>}
              {link.label}
            </Link>
          ))}
          <Link
            to="/submit"
            onClick={() => setMenuOpen(false)}
            className="px-4 py-2 rounded-full text-sm font-medium bg-[#8b5e3c] text-white text-center whitespace-nowrap"
          >
            Join Directory
          </Link>
        </div>
      )}
    </nav>
  );
}
